/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_External_Booking_ByInputs */

const en_admin_dashboard_external_booking_by = /** @type {(inputs: Admin_Dashboard_External_Booking_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`External Booking by`)
};

const de_admin_dashboard_external_booking_by = /** @type {(inputs: Admin_Dashboard_External_Booking_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Externe Buchung von`)
};

const es_admin_dashboard_external_booking_by = /** @type {(inputs: Admin_Dashboard_External_Booking_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserva externa por`)
};

const fr_admin_dashboard_external_booking_by = /** @type {(inputs: Admin_Dashboard_External_Booking_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservation externe par`)
};

const nl_admin_dashboard_external_booking_by = /** @type {(inputs: Admin_Dashboard_External_Booking_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Externe reservering door`)
};

const it_admin_dashboard_external_booking_by = /** @type {(inputs: Admin_Dashboard_External_Booking_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenotazione esterna di`)
};

const pt_br2_admin_dashboard_external_booking_by = /** @type {(inputs: Admin_Dashboard_External_Booking_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserva externa por`)
};

const pl_admin_dashboard_external_booking_by = /** @type {(inputs: Admin_Dashboard_External_Booking_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezerwacja zewnętrzna przez`)
};

const hu_admin_dashboard_external_booking_by = /** @type {(inputs: Admin_Dashboard_External_Booking_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Külső foglalás:`)
};

const ro_admin_dashboard_external_booking_by = /** @type {(inputs: Admin_Dashboard_External_Booking_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervare Externa de`)
};

/**
* | output |
* | --- |
* | "External Booking by" |
*
* @param {Admin_Dashboard_External_Booking_ByInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_external_booking_by = /** @type {((inputs?: Admin_Dashboard_External_Booking_ByInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_External_Booking_ByInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_external_booking_by(inputs)
	if (locale === "de") return de_admin_dashboard_external_booking_by(inputs)
	if (locale === "es") return es_admin_dashboard_external_booking_by(inputs)
	if (locale === "fr") return fr_admin_dashboard_external_booking_by(inputs)
	if (locale === "nl") return nl_admin_dashboard_external_booking_by(inputs)
	if (locale === "it") return it_admin_dashboard_external_booking_by(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_external_booking_by(inputs)
	if (locale === "pl") return pl_admin_dashboard_external_booking_by(inputs)
	if (locale === "hu") return hu_admin_dashboard_external_booking_by(inputs)
	return ro_admin_dashboard_external_booking_by(inputs)
});
export { admin_dashboard_external_booking_by as "admin.dashboard.external_booking_by" }